import {
  AssignmentOutlined,
  CheckRounded,
  CopyAll,
  OpenInNew,
} from "@mui/icons-material";
import {
  Box,
  Button,
  CircularProgress,
  IconButton,
  Tooltip,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import BasicModal from "./BasicModal";
import Flx from "../layout/Flx";
import Txt from "../typography/Txt";
import { green, grey } from "@mui/material/colors";

const UrlCopyPastModal = ({
  variant = "outlined",
  color = "gray",
  size = "medium",
  sx,
  show,
  description,
  title,
  urlText,
  onClose,
  startIcon,
  hideButton = false,
  endIcon,
  bodyTopContent,
  url,
  icon,
  children,
}) => {
  // loan app TextSnippet | CreditScore
  const [localShow, setLocalShow] = useState(false);

  const handleOnClose = () => {
    if (onClose) {
      onClose();
    }
    setLocalShow(false);
  };

  return (
    <>
      {hideButton ? null : (
        <Button
          onClick={() => setLocalShow(true)}
          // maxWidth="unset"
          color={color}
          variant={variant}
          size={size}
          //   maxWidth="165px"
          // disabled
          // iconSize={18}
          sx={{
            // ml: 2,
            flexGrow: 1,
            // fontStyle: "italic",
            // fontWeight: 400,
          }}
          text={"Assign Existing File"}
          startIcon={startIcon || icon}
          endIcon={endIcon}
        >
          {children || "Send App Link"}
        </Button>
      )}
      <CopyPastModal
        show={show || localShow}
        url={url}
        description={description}
        title={title}
        urlText={urlText}
        bodyTopContent={bodyTopContent}
        onClose={handleOnClose}
      />
    </>
  );
};

const CopyPastModal = ({
  urlText,
  title,
  description,
  show,
  url,
  bodyTopContent,
  onClose,
}) => {
  const handleOnClose = useCallback((props) => {
    onClose();
  }, []);

  if (!show) {
    return null;
  }
  return (
    <BasicModal
      description={description}
      // description={
      //   "This URL includes metadata that tracks the submission for this user. Please do not modify."
      // }
      title={title || "Copy & Paste Link"}
      maxWidth="sm"
      onClose={handleOnClose}
      show={show}
    >
      {bodyTopContent}
      <UrlCopyAndPaste url={url} urlText={urlText} />
    </BasicModal>
  );
};

const UrlCopyAndPaste = ({ url, urlText, loading }) => {
  const [copied, setCopied] = useState(false);
  const handleCopyToClipboard = () => {
    navigator.clipboard.writeText(url);
    setCopied(true);
  };

  const styles = useMemo(() => {
    return {
      urlText: { fontSize: "13px" },
      urlTextDescription: { fontStyle: "italic" },
      urlBox: {
        p: 1,
        background: grey[100],

        whiteSpace: "nowrap",
        display: "flex",
        overflow: "hidden",
        // position: "relative",
        // display: "inline-block",
        // textOverflow: "ellipsis",
        // whiteSpace: "nowrap",
      },
      urlBoxText: {
        fontSize: "12px",
        //
        // textOverflow: "ellipsis",
      },
    };
  }, []);

  // if (!url) {
  //   return null;
  // }

  return (
    <Flx fw column gap={1}>
      <Flx column>
        <Txt sx={styles.urlText} bold>
          {urlText}
        </Txt>

        <Txt secondary sx={styles.urlTextDescription}>
          This URL includes metadata that tracks the submission for this user.
          Please do not modify.
        </Txt>
      </Flx>
      <Box
        sx={{
          // p: 1,
          pr: 0,
          background: grey[100],
          whiteSpace: "nowrap",
          borderRadius: 1,
          border: `1px solid ${grey[200]}`,
          display: "flex",
          overflow: "hidden",
          position: "relative",
        }}
      >
        <Flx fw jb ac gap={1} sx={{ overflowX: "auto", p: 1.4, pt: 2, pr: 2 }}>
          <Txt sx={styles.urlBoxText}>
            {loading ? (
              <Flx fw center>
                <CircularProgress size={16} />
              </Flx>
            ) : (
              url
            )}
          </Txt>
        </Flx>
        <Flx
          jb
          sx={{
            // position: "absolute",
            top: 0,
            right: 0,
            background: "#f5f5f5",
            // height: 44,
            borderLeft: `1px solid ${grey[300]}`,
            // px: 1,
            // pt: 1,
            // alignItems: "flex-start",
          }}
        >
          <Tooltip
            title={copied ? "Copied To Clipboard" : "Copy To Clipboard"}
            arrow
          >
            <IconButton
              role="link"
              color={copied ? "success" : "primary"}
              onClick={handleCopyToClipboard}
              sx={{
                background: copied ? green[50] : "inherit",
                height: "100%",
                borderRadius: 0,
                px: 1.4,
              }}
              size="small"
            >
              {copied ? <CheckRounded /> : <CopyAll />}
            </IconButton>
          </Tooltip>
          <Tooltip title="Open in new tab" arrow>
            <IconButton
              role="link"
              href={url}
              color="primary"
              size="small"
              sx={{
                height: "100%",
                px: 1.4,
                borderRadius: 0,
                borderLeft: `1px solid ${grey[200]}`,
              }}
              target="_blank"
            >
              <OpenInNew />
            </IconButton>
          </Tooltip>
        </Flx>
      </Box>
    </Flx>
  );
};

export default UrlCopyPastModal;
